interface CustomIframeProps {
  src: string;
  scrolling?: 'yes' | 'no'
}

const CustomIframe = ({src, scrolling = 'no'}: CustomIframeProps) => {
  return (
    <iframe
      src={src}
      width="100%"
      height='100%'
      frameBorder={0}
      scrolling={scrolling}
      allow="fullscreen;"
    />
  )
}

export default CustomIframe